import { Typography } from '@mui/material';
import PaypalIcon from '@nrdy-marketing-engine/payment-forms/src/paypal.svg?svgr';
import { PaymentType } from '../../../hooks/use-payment';
import ContinueButton from '../../shared/continue-button';
import PaypalButton from '../../shared/paypal-button';

interface PaymentButtonProps {
  loading: boolean;
  onClick: () => void;
  paymentRequestable: boolean;
  paymentType: PaymentType;
}

function PaymentButton({ paymentType, loading, paymentRequestable, onClick }: PaymentButtonProps) {
  return paymentType === 'PayPalAccount' ? (
    <PaypalButton disabled={loading || !paymentRequestable} loading={loading} onClick={onClick}>
      <Typography>Buy with</Typography>
      <PaypalIcon alt="Paypal" aria-label="Paypal" />
    </PaypalButton>
  ) : (
    <ContinueButton disabled={loading || !paymentRequestable} loading={loading} onClick={onClick}>
      Confirm payment
    </ContinueButton>
  );
}

export default PaymentButton;
